import { webRoutes } from '@runhuman/shared';
import { WEB_BASE_URL } from './web-base-url';

/**
 * Absolute URLs the Activity hands off to a real browser tab via
 * `getDiscordSdk().commands.openExternalLink`. Centralised here so every
 * "leaves the iframe" affordance shares one source of truth — change the
 * route once in `@runhuman/shared/web-routes` and every Activity hand-off
 * picks it up.
 */
export const TESTER_SCHEDULE_URL = new URL(
  webRoutes.testerScheduleView.build(),
  WEB_BASE_URL,
).toString();
